<template>
  <div class="header">
    <slot name="header"></slot>
    <v-layout row align-center justify-end class="body-2 extraGrey--text font-weight-medium">
      <div :style="{ width: '30%' }">{{ $t('Present Month') }}</div>
      <div :style="{ width: '40%' }">{{ $t('Last Month') }}</div>
    </v-layout>
    <div>
      <v-layout row justify-center>
        <v-flex xs2 />
        <v-flex xs2 class="subheading">
          <v-layout column :style="{ rowGap: '10px' }">
            <div>{{ $t('Best') }}</div>
            <div>{{ $t('Least') }}</div>
          </v-layout>
        </v-flex>
        <v-flex xs2>
          <v-layout column :style="{ rowGap: '10px' }">
            <div>
              <v-icon>trending_up</v-icon>
            </div>
            <div>
              <v-icon>trending_down</v-icon>
            </div>
          </v-layout>
        </v-flex>
        <v-flex xs1 />
        <v-flex xs1>
          <div class="divider"></div>
        </v-flex>
        <v-flex xs10>
          <v-layout column :style="{ rowGap: '8px' }">
            <v-tooltip color="bg" bottom :disabled="header.best.present.name.length <= 1">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <span class="caption">{{ header.best.present.name[0] }}</span>
                  <sub class="smaller-caption"
                    v-if="header.best.present.name.length > 1">(+{{header.best.present.name.length -1}}
                    {{ $t('others') }})</sub>
                </div>
              </template>
              <div id="hover__card" class="tool-tip__color">
                <div class="text-xs-center">
                  <span class="body-1 font-weight-bold">
                    {{ $t('Other best inv') }}
                  </span>
                  <span>
                    ({{ $t('Present Month') }})
                  </span>
                </div>
                <div
                  :style="{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }">
                  <div v-for="(h, index) in header.best.present.name" :key="index">
                    {{ h }}</div>
                </div>
              </div>
            </v-tooltip>

            <v-tooltip color="bg" bottom :disabled="header.least.present.name.length <= 1">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <span class="caption">{{ header.least.present.name[0] }}</span>
                  <sub class="smaller-caption"
                    v-if="header.least.present.name.length > 1">(+{{header.least.present.name.length -1}}
                    {{ $t('others') }})</sub>
                </div>
              </template>
              <div id="hover__card" class="tool-tip__color">
                <div class="text-xs-center"><span class="body-1 font-weight-bold">{{ $t('Other least inv') }}
                  </span><span>({{ $t('Present Month') }})</span></div>
                <div
                  :style="{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }">
                  <div v-for="(h, index) in header.least.present.name" :key="index">
                    {{ h }}</div>
                </div>
              </div>
            </v-tooltip>
          </v-layout>
        </v-flex>
        <v-flex xs2 class="text-xs-right">
          <v-layout column :style="{ rowGap: '10px' }">
            <div><span :class="header.best.present.value == null || header.best.present.value == 'No Data' ? 'title error--text' : 'title number--text'">{{ header.best.present.value }}</span><span
                class="smaller-caption">{{ header.unit }}</span>
            </div>
            <div><span :class="header.least.present.value == null || header.least.present.value == 'No Data' ? 'title error--text' : 'title number--text'">{{ header.least.present.value }}</span><span
                class="smaller-caption">{{ header.unit }}</span>
            </div>
          </v-layout>
        </v-flex>
        <v-flex xs1> </v-flex>
        <v-flex xs1>
          <div class="divider"></div>
        </v-flex>
        <v-flex xs10>
          <v-layout column :style="{ rowGap: '8px' }">
            <v-tooltip color="bg" bottom :disabled="header.best.last.name.length <= 1">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <span class="caption">{{ header.best.last.name[0] }}</span>
                  <sub class="smaller-caption"
                    v-if="header.best.last.name.length > 1">(+{{header.best.last.name.length -1}}
                    {{ $t('others') }})</sub>
                </div>
              </template>
              <div id="hover__card" class="tool-tip__color">
                <div class="text-xs-center"><span class="title font-weight-bold">{{ $t('Other best inv') }}
                  </span><span>({{ $t('Last Month') }})</span></div>
                <div
                  :style="{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }">
                  <div v-for="(h, index) in header.best.last.name" :key="index">
                    {{ h }}</div>
                </div>
              </div>
            </v-tooltip>
            <v-tooltip color="bg" bottom :disabled="header.least.last.name.length <= 1">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <span class="caption">{{ header.least.last.name[0] }}</span>
                  <sub class="smaller-caption"
                    v-if="header.least.last.name.length > 1">(+{{header.least.last.name.length -1}}
                    {{ $t('others') }})</sub>
                </div>
              </template>
              <div id="hover__card" class="tool-tip__color">
                <div class="text-xs-center"><span class="title font-weight-bold">{{ $t('Other least inv') }}
                  </span><span>({{ $t('Last Month') }})</span></div>
                <div
                  :style="{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }">
                  <div v-for="(h, index) in header.least.last.name" :key="index">
                    {{ h }}</div>
                </div>
              </div>
            </v-tooltip>
          </v-layout>
        </v-flex>
        <v-flex xs2 class="text-xs-right">
          <v-layout column :style="{ rowGap: '10px' }">
            <div><span :class="header.best.last.value == null || header.best.last.value == 'No Data' ? 'title error--text' : 'title number--text'">{{ header.best.last.value }}</span><span
                class="smaller-caption">{{ header.unit }}</span>
            </div>
            <div><span :class="header.least.last.value == null || header.least.last.value == 'No Data' ? 'title error--text' : 'title number--text'">{{ header.least.last.value }}</span><span
                class="smaller-caption">{{ header.unit }}</span>
            </div>
          </v-layout>
        </v-flex>
        <v-flex xs1></v-flex>
        <v-flex xs1>
          <div class="divider" />
        </v-flex>
        <v-flex xs1 />
        <v-flex xs3 class="text-xs-right">
          <v-layout column :style="{ rowGap: '10px' }">
            <span :class='textComputedColor(header.best.trend)'>
              {{ header.best.trend.flow ? header.best.trend.value : $t(header.best.trend.value) }}
              <span class="smaller-caption">{{ header.best.trend.flow ? '%' : '' }}</span>
            </span>
            <span :class='textComputedColor(header.least.trend)'>
              {{ header.least.trend.flow ? header.least.trend.value : $t(header.least.trend.value) }}
              <span class="smaller-caption">{{ header.least.trend.flow ? '%' : '' }}</span>
            </span>
          </v-layout>
        </v-flex>
        <v-flex xs1>
          <v-layout column :style="{ paddingLeft: '5px' }">
            <div>
              <v-icon medium>{{ header.best.trend.flow == 'up' || header.best.trend.value == 'up' ? 'arrow_upward' : 'arrow_downward' }}</v-icon>
            </div>
            <div>
              <v-icon medium>{{ header.least.trend.flow == 'up' || header.least.trend.value == 'up' ? 'arrow_upward' : 'arrow_downward' }}</v-icon>
            </div>
          </v-layout>
        </v-flex>
        <v-flex xs2 />
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  methods: {
    textComputedColor(value) {
      if (value.flow === 'up' || value.value === 'up') {
        return 'title success--text'
      } else {
        return 'title error--text'
      }
    }
  }
}
</script>

<style scoped>
.header {
  height: 130px;
  border-radius: 5px;
  background-color: var(--v-primary-base);
}

.header-layout {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.divider {
  border-left: 3px solid var(--v-warning-base);
  height: 4.4375rem;
  margin-top: -0.625rem;
}

.theme--dark .smaller-caption {
  font-size: 12px;
  color: var(--v-grey-base);
}

.theme--light .smaller-caption {
  font-size: 12px;
  color: var(--v-black-base);
}

.text-danger {
  color: var(--v-error-base);
}

.text-success {
  color: var(--v-green-base);
}

#hover__card {
  width: 320px;
  padding: 10px;
}
</style>
